import PropTypes from 'prop-types'

const Badge = ({ children, className, color }) => {
  return <div className={`badge badge__${color || 'gray'} ${className || ''}`}>{children}</div>
}

Badge.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'purple',
    'orange',
    'orange-filled',
    'red',
    'red-filled',
    'green',
    'green-filled',
    'gray',
  ]),
}

export default Badge
